import * as Yup from 'yup';
import { validUSState } from 'common/helpers/yup-helpers';

Yup.addMethod(Yup.mixed, 'validUSState', validUSState);

export const motgageValidation = Yup.object().shape({
  loanNumber: Yup.number().required('Loan number is required').typeError('Loan Number must be a number'),
  mortgageHolderName: Yup.string().required('Holder Name is required'),
  mortgageHolderAddress: Yup.object({
    address: Yup.string().required('Holder Address is required'),
    address2: Yup.string().nullable(),
    country: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().ensure().validUSState('mortgage.state'),
    zip: Yup.string().nullable()
  })
});
